import React, { useEffect, useState } from "react";
import CustomPagination from "../components/Shared/CustomPagination";
import { FaEye, FaPrint } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import CustomTable from "../components/Shared/CustomTable";
import Filters from "./Filters";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import supergitHIS from "../api/supergitHIS";
import validSupergitHIS from "../api/validSupergitHIS";
import toast from "react-hot-toast";
import TableLoading from "../components/Shared/TableLoading";
import SharedButton from "../components/Shared/SharedButton";
import { getDateRange } from "./ThirdParty";
import moment from "moment";
import { TfiStatsUp } from "react-icons/tfi";
import { Dialog } from "primereact/dialog";
import QRCode from "react-qr-code";
import LogModal from "./LogModal";
import { ProgressSpinner } from "primereact/progressspinner";
import { FaFileInvoice, FaPencil } from "react-icons/fa6";
import InvoiceDetails from "./InvoiceDetails";
import { useSelector } from "react-redux";
import StoreUpdate from "./StoreUpdate";
import StoreFilters from "./StoreFilters";
import { MdCancel } from "react-icons/md";

const StoreInvoicesMain = ({ activeTab }) => {
  const key = "store-main-invoices";
  const { user } = useSelector((state) => state?.auth);
  const [openFilter, setOPenFilters] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [zatcaIndex, setZatcaIndex] = useState(-1);
  const [zatcaLoading, setZatcaLoading] = useState(false);
  const [logLoading, setLogLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [vsData, setVsData] = useState(null);
  const [editVisible, setEditVisible] = useState(false);
  const [isPollLoading, setIsPollLoading] = useState(false);
  const [cancel, setCancel] = useState(false);

  const [date, setDate] = useState({
    from: getDateRange("lastDay").from,
    to: getDateRange("lastDay").to,
  });

  const [payload, setPayload] = useState(
    localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : {
        orderDateFrom: null,
        orderDateTo: null,
        ClientOrderID: null,
        zatcaStatus: null,
        storeId: user?.thirdparty_branch_id,
        page: 1,
        pageSize: 10,
      },
  );
  const [data, setData] = useState([]);
  const [isListLoading, setIsListLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [logsData, setLogsData] = useState(null);

  const templateBody = (rowData, col) => (
    <div className="flex gap-3 items-center justify-center">
      <FaFileInvoice
        className=" cursor-pointer"
        size={16}
        title=" Invoice Details"
        onClick={() => {
          getInvoiceDetails(rowData?.ClientOrderID).then(() => {
            setVisible(true);
          });
        }}
      />
      <FaPencil
        className=" cursor-pointer"
        size={16}
        title="Invoice Details"
        onClick={() => {
          getInvoiceDetails(rowData?.ClientOrderID).then(() => {
            setEditVisible(true);
          });
        }}
      />
      {rowData?.ZatcaStatus || rowData?.zatcaStatus !== "REPORTED" ? null : (
        <FaPrint
          className=" cursor-pointer"
          size={16}
          title="Details"
          onClick={() => {
            navigate(`/zatca/thirdparty/invoice-details/${rowData.InvoiceId}`, {
              state: {
                status: rowData?.ZatcaStatus || rowData?.zatcaStatus,
                module: activeTab,
                url: "invoices/zatca",
                invoiceData: rowData,
              },
            });
          }}
        />
      )}
      {logLoading && col?.rowIndex == zatcaIndex ? (
        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
      ) : (
        <TfiStatsUp
          className=" cursor-pointer"
          size={16}
          title="View Logs"
          onClick={() => handleViewLogs(rowData.ClientOrderID)}
        />
      )}
      {rowData?.ZatcaStatus || rowData?.zatcaStatus === "REPORTED" ? null : zatcaLoading &&
        col?.rowIndex == zatcaIndex ? (
        <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
      ) : (
        <IoIosSend
          className=" cursor-pointer"
          size={16}
          title="Send To Zatca"
          onClick={() => {
            SendToZatca(rowData.ClientOrderID);
          }}
        />
      )}

      <MdCancel
        size={28}
        data-tooltip-id="cancel"
        className="!p-1 !text-red-500 cursor-pointer"
        onClick={() => {
          getInvoiceDetails(rowData?.ClientOrderID).then(() => {
            setEditVisible(true);
            setCancel(true);
          });
        }}
      />
    </div>
  );
  const statusTemplate = (rowData) => {
    return (
      <div>
        {rowData?.ZatcaStatus || rowData?.zatcaStatus === "REPORTED" ? (
          <div className="bg-green-500 !w-[100px] p-1 text-center text-white rounded-md">
            {rowData?.ZatcaStatus || rowData?.zatcaStatus}
          </div>
        ) : (
          <div className="bg-red-500 p-1 !w-[100px] text-center text-white rounded-md">
            UNREPORTED
          </div>
        )}
      </div>
    );
  };

  const columnsData = [
    { body: templateBody, header: t("Actions") },
    { body: statusTemplate, header: t("Zatca Status") },
    {
      field: "ClientOrderID",
      header: t("Order Id"),
      style: { width: "8rem" },
    },
    {
      header: t("invoiceNumber"),
      body: (rowData) => rowData?.InvoiceId,
      header: t("Invoice"),
    },
    { field: "ClientName", header: t("Client Name") },
    {
      field: "OrderDate",
      header: t("Order Date"),
      body: (rowData) =>
        moment(rowData?.orderDate || rowData?.OrderDate).format(
          "DD-MM-YYYY HH:mm a",
        ),
    },
    { field: "StoreName", header: t("Store Name") },
    { field: "LocalSerial", header: t("Local Serial") },
    { field: "SalesPersonName", header: t("Sales Person Name") },
    {
      field: "TotalPrice",
      header: t("Total Price"),
      body: (rowData) => `${rowData.TotalPrice} SAR`,
    },
    { field: "Address", header: t("Address") },
    { field: "FirstPhone", header: t("First Phone") },
    {
      body: (data) => (
        <div>{data?.TotalPrice > 1000 && data?.ClientVAt ? "B2B" : "B2C"}</div>
      ),
      header: t("Type"),
    },
  ];

  const onPageChange = (page, rowsPerPage) => {
    setPayload({ ...payload, page, pageSize: rowsPerPage });
  };

  const SendToZatca = async (id) => {
    try {
      setZatcaLoading(true);
      const res = await validSupergitHIS.post(
        `zatca2/sendInvoiceToZatcaClient/${id}/8ab7f7d1-8fa2-47a8-966d-97fbec298e31`,
      );
      toast.success(res.data?.message);
      await fetchListData(payload);
      setZatcaLoading(false);
    } catch (err) {
      setZatcaLoading(false);
      console.error(err);
    }
  };
  const handleViewLogs = async (id) => {
    try {
      setLogLoading(true);
      const res = await validSupergitHIS.get(`invoices/zatca/logs/${id}`);
      setLogsData(res?.data);
      setLogLoading(false);
    } catch (err) {
      setLogLoading(false);
      console.error(err);
    }
  };

  const fetchPollData = async () => {
    setIsPollLoading(true);
    try {
      const response = await validSupergitHIS.post(
        `hussam/transfer/client-orders/sync?from_date=${date.to}`,
      );
      toast.success(response?.data?.message);
      fetchListData(payload);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsPollLoading(false);
    }
  };

  const fetchListData = async (filters = payload) => {
    setIsListLoading(true);
    try {
      const response = await validSupergitHIS.post(
        "invoices/clientOrders/filter",
        filters,
      );
      setData(response.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsListLoading(false);
    }
  };

  const getInvoiceDetails = async (payload) => {
    setIsListLoading(true);
    try {
      const response = await validSupergitHIS.get(
        `invoices/clientOrders/details/${payload}`,
      );
      const data = response.data;
      setVsData(data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsListLoading(false);
    }
  };

  useEffect(() => {
    fetchListData(payload);
  }, [payload.page, payload?.pageSize]);

  const onFilterSelect = (id) => {
    const updatedPayload = { ...payload, storeId: id };
    setPayload(updatedPayload);
    localStorage.setItem("store-main-invoices", JSON.stringify(updatedPayload));
    fetchListData(updatedPayload);
  };

  return (
    <div>
      <div className=" flex justify-between items-center">
        <StoreFilters onSelect={onFilterSelect} filters={payload} />
        <div className="flex items-center justify-end mb-2 gap-2">
          <SharedButton
            icon="pi pi-sync"
            label={
              <div className="flex items-center gap-2">
                {t("Polling")}
                {isPollLoading && (
                  <ProgressSpinner
                    className="w-5 h-5 spinner-white"
                    style={{ stroke: "white" }}
                  />
                )}
              </div>
            }
            disabled={isPollLoading}
            className="bg-primary primary-btn"
            onClick={fetchPollData}
          />
          {/* <SharedButton
          icon="pi pi-filter"
            label={t("apply_filters")}
            severity="warning"
            outlined
            className="!p-1.5 font-extralight !border-primary !text-primary"
            onClick={() => setOPenFilters(true)}
          /> */}
        </div>
      </div>
      <Filters
        storageKey={key}
        visible={openFilter}
        setVisible={() => setOPenFilters(false)}
        filters={payload}
        setFilters={setPayload}
        fetchData={fetchListData}
        loading={isLoading}
        store
      />
      <CustomTable
        data={data?.data}
        isLoading={isListLoading || zatcaLoading || logLoading || isPollLoading}
        setZatcaIndex={setZatcaIndex}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        rows={data.total}
      />
      <CustomPagination
        currentPage={data?.page || payload?.page}
        rowsPerPage={data?.page_size || data?.pageSize || payload?.pageSize || 10}
        totalRecords={
          data?.total_pages ||
          data?.totalPages ||
          Math.ceil(
            (data?.total_records ||
              data?.totalRecords ||
              data?.summary?.totalRecords ||
              data?.total_record ||
              0) / (data?.page_size || data?.pageSize || payload?.pageSize || 10),
          )
        }
        totalRecord={
          data?.total_records ||
          data?.totalRecords ||
          data?.summary?.totalRecords ||
          data?.total_record ||
          0
        }
        onPageChange={onPageChange}
      />

      <LogModal logsData={logsData} setLogsData={setLogsData} />
      <InvoiceDetails
        visible={visible}
        onHide={() => {
          setVisible(false);
          setVsData(null);
        }}
        data={vsData}
      />
      <StoreUpdate
        visible={editVisible}
        setVisible={setEditVisible}
        setCancel={setCancel}
        cancel={cancel}
        invoiceData={vsData}
        setInvoiceData={setVsData}
        fetchAgain={fetchListData}
      />
    </div>
  );
};

export default StoreInvoicesMain;
